<template>
  <section
    class="links"
    data-wptv="links-section">
    <div class="services">
      <h3
        class="mb-0 h4"
        data-wptv="links-section-services-titre">
        {{ linksSection.services.title }}
      </h3>
      <div>
        <ul class="menu">
          <li
            v-for="(service, idx) in linksSection.services.servicesLinks"
            :key="idx">
            <a
              v-tealium:click="createStats(service.name, getLink(service.linkRef))"
              :href="getLink(service.linkRef)"
              :aria-label="service.ariaLabel"
              class="o-link o-link-reverse no-decoration pb-0"
              data-wptv="menu-services">
              {{ service.label }}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <h3
          class="mb-0 h4"
          data-wptv="links-section-options-titre">
          {{ linksSection.options.title }}
        </h3>
        <div>
          <ul class="menu">
            <li
              v-for="(option, idx) in linksSection.options.optionsLinks"
              :key="idx">
              <a
                v-tealium:click="createStats(option.name, getLink(option.linkRef))"
                :href="getLink(option.linkRef)"
                :aria-label="option.ariaLabel"
                class="o-link o-link-reverse no-decoration pb-0"
                data-wptv="menu-options">
                {{ option.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="assist">
      <h3
        class="mb-0 h4"
        data-wptv="links-section-general-titre">
        {{ linksSection.assist.title }}
      </h3>
      <div>
        <ul class="menu">
          <li
            v-for="(assist, idx) in linksSection.assist.assistLinks"
            :key="idx">
            <a
              v-tealium:click="createStats(assist.name, getLink(assist.linkRef))"
              :href="getLink(assist.linkRef)"
              :aria-label="assist.ariaLabel"
              class="o-link o-link-reverse no-decoration pb-0"
              target="_blank"
              data-wptv="menu-general">
              {{ assist.label }}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <h3
          class="mb-0 h4"
          data-wptv="links-section-general-titre">
          {{ linksSection.general.title }}
        </h3>
        <div>
          <ul class="menu">
            <li
              v-for="(general, idx) in linksSection.general.generalLink"
              :key="idx">
              <a
                v-tealium:click="createStats(general.name, getLink(general.linkRef))"
                :href="getLink(general.linkRef)"
                :aria-label="general.ariaLabel"
                class="o-link o-link-reverse no-decoration pb-0"
                target="_blank"
                data-wptv="menu-assist">
                {{ general.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _get from 'lodash/get'
export default {
  name: 'LinksSection',
  props: {
    linksSection: {
      type: Object,
      required: true
    }
  },
  methods: {
    getLink (linkRef) {
      return _get(this.$config, linkRef)
    },
    createStats (name, cible) {
      return {
        track_page: 'home',
        track_zone: 'footer',
        track_nom: name,
        track_cible: cible,
        track_type: 'clic'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/abstracts/variables';
@import '../../../scss/abstracts/mixins';

.links {
  display: flex;
  flex-wrap: nowrap;
  .services,
  .assist {
    margin-right: 1.875rem;
    flex: 1;
  }

  .menu {
    display: inline-block;
    flex: 1;
    padding: 5px 0 10px;
    justify-content: space-between;

    li {
      margin-bottom: 12px;

      a {
        display: inline-block;
        width: 100%;
        margin-left: 0;
      }
    }
  }
}
</style>
